export type FontWeight = 300 | 400 | 500 | 600 | 700 | 800 | 900 | 'normal' | 'bold';

export const TEXT_DEFAULTS = {
  version: '7.1.0',
  fontFamily: 'DM Sans',
  fontStyle: 'normal',
  styles: [],
  pathStartOffset: 0,
  pathSide: 'left',
  pathAlign: 'baseline',
  underline: false,
  overline: false,
  linethrough: false,
  textBackgroundColor: '',
  direction: 'ltr',
  textDecorationThickness: 66.667,
  minWidth: 20,
  splitByGrapheme: false,
  stroke: null,
  strokeWidth: 1,
  selectable: true,
  evented: true,
  charSpacing: 0,
  originX: 'center'
} as const;
